import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Wraps any route that requires the user to be logged in.
// If adminOnly is true, the user also needs isAdmin = true in Firestore.
function PrivateRoute({ children, adminOnly = false }) {
  const { currentUser, isAdmin } = useAuth();

  // Not logged in — send to login page
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Logged in but not an admin — send back home
  if (adminOnly && !isAdmin) {
    return <Navigate to="/" />;
  }

  return children;
}

export default PrivateRoute;
